module.exports = __webpack_public_path__ + "img/progress-scribble-bar-color2.7fb440d9.gif";